const ACCESS_TOKEN_KEY = "eatta_hr_access_token";
const TOKEN_TYPE_KEY = "eatta_hr_token_type";
const EXPIRES_AT_KEY = "eatta_hr_expires_at";

type SessionPayload = {
  accessToken: string;
  tokenType?: string;
  expiresAt?: string;
};

export function setAuthSession(payload: SessionPayload) {
  localStorage.setItem(ACCESS_TOKEN_KEY, payload.accessToken);

  if (payload.tokenType) {
    localStorage.setItem(TOKEN_TYPE_KEY, payload.tokenType);
  }

  if (payload.expiresAt) {
    localStorage.setItem(EXPIRES_AT_KEY, payload.expiresAt);
  }
}

export function getStoredToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getStoredTokenType() {
  return localStorage.getItem(TOKEN_TYPE_KEY) || "Bearer";
}

export function getStoredExpiresAt() {
  return localStorage.getItem(EXPIRES_AT_KEY);
}

export function clearAuthStorage() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(TOKEN_TYPE_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}